export default __webpack_public_path__ + "static/media/disadvantage.f3bbc7a3.svg";